import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { config } from "../../../config";

const imageUrl = config.imageUrl;

const UpdateService = ({
  formData,
  handleQuillChange,
  handleChange,
  handleSubmit,
  membershipsForServices,
  setPhoto,
  loading,
  error,
}) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Service</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating Service...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Service Image */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Image</label>
          {formData.image && (
            <img
              src={`${imageUrl}/${formData.image}`}
              alt="Service"
              height={200}
              width={200}
              className="mb-2"
            />
          )}
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>

        {/* Service Name */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Service Name</label>
          <input
            type="text"
            name="service_name"
            value={formData.service_name}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter service name"
            required
          />
        </div>

        {/* Service Description */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Description</label>
          <ReactQuill
            value={formData.description || ""}
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div>

        {/* Service Duration */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Duration (months)</label>
          <input
            type="text"
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter duration"
            required
          />
        </div>

        {/* Selling Price */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Selling Price</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter selling price"
            required
          />
        </div>

        {/* Discount Price */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Discount Price</label>
          <input
            type="number"
            name="discount_price"
            value={formData.discount_price}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter discount price"
            required
          />
        </div>

        {/* Membership Type */}
        <div className="mb-4">
          <label className="block text-gray-700">Membership Type</label>
          <select
            name="membership_type"
            value={formData.membership_type}
            onChange={handleChange}
            className="border w-full p-2"
          >
            <option value="">Select Membership Type</option>
            {membershipsForServices?.map((membership) => (
              <option key={membership.id} value={membership.id}>
                {membership.membership_type}
              </option>
            ))}
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Service"}
        </button>
      </form>
    </div>
  );
};

export default UpdateService;
